import { render, staticRenderFns } from "./SettingsMrDocumentTemplates.vue?vue&type=template&id=ca665556"
import script from "./SettingsMrDocumentTemplates.vue?vue&type=script&lang=js"
export * from "./SettingsMrDocumentTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports